import { ballColorMap, hitLocationColorMap } from "./ColorMap"

export const resolveBubbleChartData = (chartdata) => {
  let zoneData = [], fieldData = [], zonelabels = []
  let groupByPTZ = {}, groupByPTF = {}
  for (const p of chartdata.zone) {
    if (groupByPTZ[p.label] === undefined) {
      groupByPTZ[p.label] = []
      zonelabels.push(p.label)
    }
    groupByPTZ[p.label].push(p)
  }
  for (const l of chartdata.field) {
    if (groupByPTF[l.label] === undefined) {
      groupByPTF[l.label] = []
    }
    groupByPTF[l.label].push(l)
  }

  for (const p in groupByPTZ) {
    zoneData.push({
      label: p,
      data: groupByPTZ[p],
      pointBackgroundColor: ballColorMap[p],
    })
  }

  for (const l in groupByPTF) {
    fieldData.push({
      data: groupByPTF[l],
      ...hitLocationColorMap[l],
    })
  }

  return {zone: {labels: zonelabels, datasets: zoneData}, field: {datasets: fieldData}}
}